import { type GridColDef, Text } from '@shared/components';

export interface MonthlyExamEventListItem {
  month: string;
  period: string;
  examCourseCount: number;
  examEventCount: number;
}

export const columns: GridColDef<MonthlyExamEventListItem>[] = [
  {
    field: 'no',
    headerName: 'No',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
  },
  {
    field: 'period',
    headerName: 'รายการตารางสอบ',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => <Text variant='body1Semibold'>{row.period}</Text>,
  },
  {
    field: 'examCourseCount',
    headerName: 'หลักสูตร',
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    width: 128,
  },
  {
    field: 'examEventCount',
    headerName: 'รอบสอบ',
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    width: 128,
  },
];
